const getDMSerifStyles = (fontSize, lineHeight, letterSpacing) => ({
  fontFamily: "DM Serif Text",
  fontWeight: "400",
  fontSize,
  lineHeight,
  letterSpacing
});
const getLatoStyles = (fontWeight, fontSize, lineHeight, letterSpacing) => ({
  fontFamily: "Lato",
  fontWeight,
  fontSize,
  lineHeight,
  letterSpacing
});
const getSarabunStyles = (fontWeight, fontSize, lineHeight, letterSpacing) => ({
  fontFamily: "Sarabun",
  fontWeight,
  fontSize,
  lineHeight,
  letterSpacing
});
const typographyVariants = {
  "DM Serif H1": getDMSerifStyles("70px", "80px", "-0.5px"),
  "DM Serif H2": getDMSerifStyles("48px", "58px", "0px"),
  "DM Serif H3": getDMSerifStyles("30px", "36px", "0.25px"),
  "DM Serif H4": getDMSerifStyles("26px", "32px", "0.25px"),
  "DM Serif H5": getDMSerifStyles("22px", "28px", "0.25px"),
  "DM Serif Subtitle 1": getDMSerifStyles("18px", "24px", "0.25px"),
  "DM Serif Subtitle 2": getDMSerifStyles("16px", "24px", "0.5px"),
  "Lato H1": getLatoStyles("300", "70px", "80px", "-1.5px"),
  "Lato H2": getLatoStyles("400", "50px", "64px", "0px"),
  "Lato H3": getLatoStyles("400", "36px", "48px", "0.25px"),
  "Lato H3 Bold": getLatoStyles("700", "36px", "48px", "0.25px"),
  "Lato H4": getLatoStyles("400", "24px", "32px", "0px"),
  "Lato H4 Bold": getLatoStyles("700", "24px", "32px", "0px"),
  "Lato H5": getLatoStyles("400", "20px", "28px", "0.15px"),
  "Lato H5 Bold": getLatoStyles("700", "20px", "28px", "0.15px"),
  "Lato Emphasized 1": getLatoStyles("700", "16px", "22px", "0.5px"),
  "Lato Emphasized 2": getLatoStyles("700", "14px", "20px", "0.25px"),
  "Lato Link 1": {
    ...getLatoStyles("700", "16px", "22px", "0.5px"),
    textDecoration: "underline"
  },
  "Lato Link 2": {
    ...getLatoStyles("700", "14px", "20px", "0.25px"),
    textDecoration: "underline"
  },
  "Lato Link 3": {
    ...getLatoStyles("700", "12px", "16px", "0.4px"),
    textDecoration: "underline"
  },
  "Lato Body 1": getLatoStyles("400", "16px", "22px", "0.5px"),
  "Lato Body 2": getLatoStyles("400", "14px", "20px", "0.25px"),
  "Lato Caption": getLatoStyles("400", "12px", "16px", "0.4px"),
  "Lato Caption Bold": getLatoStyles("700", "12px", "16px", "0.4px"),
  "Lato Caption Small": getLatoStyles("500", "10px", "16px", "0.5px"),
  "Lato Caption Small Bold": getLatoStyles("700", "10px", "16px", "0.5px"),
  "Lato Button": {
    ...getLatoStyles("700", "12px", "16px", "0.5px"),
    textTransform: "uppercase"
  },
  "Lato Overline": {
    ...getLatoStyles("400", "10px", "12px", "1px"),
    textTransform: "uppercase"
  },
  "Lato Overline Bold": {
    ...getLatoStyles("700", "10px", "12px", "0.5px"),
    textTransform: "uppercase"
  },
  "Sarabun H1": getSarabunStyles("300", "88px", "104px", "-1.5px"),
  "Sarabun H2": getSarabunStyles("300", "64px", "80px", "-0.5px"),
  "Sarabun H3": getSarabunStyles("400", "51px", "64px", "0px"),
  "Sarabun H4": getSarabunStyles("400", "36px", "48px", "0.25px"),
  "Sarabun H5": getSarabunStyles("400", "25px", "32px", "0px"),
  "Sarabun H6": getSarabunStyles("500", "21px", "28px", "0.15px"),
  "Sarabun Subtitle 1": getSarabunStyles("500", "17px", "24px", "0.5px"),
  "Sarabun Subtitle 2": getSarabunStyles("500", "15px", "24px", "0.25px"),
  "Sarabun Body 1": getSarabunStyles("400", "17px", "24px", "0.5px"),
  "Sarabun Body 2": getSarabunStyles("400", "15px", "24px", "0.25px"),
  "Sarabun Link 1": {
    ...getSarabunStyles("700", "17px", "24px", "0.5px"),
    textDecoration: "underline"
  },
  "Sarabun Link 2": {
    ...getSarabunStyles("700", "15px", "24px", "0.25px"),
    textDecoration: "underline"
  },
  "Sarabun Button": getSarabunStyles("700", "15px", "20px", "1.25px"),
  "Sarabun Caption": getSarabunStyles("400", "13px", "18px", "0.4px"),
  "Sarabun Overline": getSarabunStyles("500", "11px", "16px", "1.5px")
};
export {
  typographyVariants
};
